module.exports = __webpack_public_path__ + "static/media/10_years_warranty.a9aa38af.svg";